'use client';
var SubscriptionResponse = /*#__PURE__*/ function() {
    function SubscriptionResponse() {}
    SubscriptionResponse.isNotValid = function isNotValid(data) {
        var _data_error, _data_errors_some, _data_errors;
        return (data == null ? void 0 : (_data_error = data.error) == null ? void 0 : _data_error.code) === "validation.error" || (data == null ? void 0 : (_data_errors = data.errors) == null ? void 0 : (_data_errors_some = _data_errors.some) == null ? void 0 : _data_errors_some.call(_data_errors, function(error) {
            var parts = error.id.split("/");
            return parts.includes("email_format");
        }));
    };
    SubscriptionResponse.isAlreadySubscribed = function isAlreadySubscribed(data) {
        var _data_errors_some, _data_errors;
        return data == null ? void 0 : (_data_errors = data.errors) == null ? void 0 : (_data_errors_some = _data_errors.some) == null ? void 0 : _data_errors_some.call(_data_errors, function(error) {
            return error.id === "member_exists";
        });
    };
    return SubscriptionResponse;
}();

export { SubscriptionResponse };
